/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
// import store from '../store.js'
import CryptoJS from 'crypto-js'
import Vue from "vue"
import router from '../router'
import SHA1 from 'sha1'
import { Message } from 'iview';
import Fingerprint2 from 'fingerprintjs2'
console.log(CryptoJS)
export let getAesString = function (data) {
    var eKey = "sa#65$f4";
    var ivs = "gzsyfdgs";
    var key = CryptoJS.enc.Utf8.parse(eKey);
    var iv = CryptoJS.enc.Utf8.parse(ivs);
    var encrypted = CryptoJS.DES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

export function getAesStringNew(str) {
    var key = CryptoJS.enc.Utf8.parse("LianOuYiShengDuanLianOuYiShengPc");
    var iv = CryptoJS.enc.Utf8.parse("LotusRootHealthy");
    var encrypted = '';
    var srcs = CryptoJS.enc.Utf8.parse(str);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString();
};
export function jieming(str) {
    var key = CryptoJS.enc.Utf8.parse("LianOuYiShengDuanLianOuYiShengPc");
    var iv = CryptoJS.enc.Utf8.parse("LotusRootHealthy");
    var encryptedHexStr = CryptoJS.enc.Hex.parse(str);
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    var decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
    });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
};
// console.log(encryptByDES(str,key))

//  console.info("环境:",process.env.NODE_ENV)
// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_OnlineConsultation // 请求地址
// 请求超时时间
axios.defaults.timeout = 100000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
function getuniaooid() {
    return new Promise((resolve, reject) => {
        // resolve(123456);
        let murmur;
        Fingerprint2.get((components) => {
            const values = components.map((component, index) => {
                if (index === 0) {
                    //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                    return component.value.replace(/\bNetType\/\w+\b/, "");
                }
                return component.value;
            });
            // 生成最终id murmur
            murmur = Fingerprint2.x64hash128(values.join(""), 31);
            resolve(murmur);
        });
    });
}
// 请求拦截器
axios.interceptors.request.use(
    async config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        //  const token = store.state.Token;
        //  token && (config.headers.Authorization = token);
        let uin = await getuniaooid();
        // let cid = getCookie("uniqueId");
        config.headers.access_token = getCookie("access_token");
        let lastUin = getCookie("uniqueId");
        if (!lastUin || lastUin == "null" || lastUin == 0 || lastUin == "undifind") {
            config.headers.uniqueId = uin;
        } else {
            config.headers.uniqueId = getCookie("uniqueId")
        }
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                    // alert("登录过期")
                    Message.error("登录过期")
                    sessionStorage.clear();
                    router.push({ path: "/login" })
                    break;
                case 404:
                    Message.error("网络请求不存在")
                    break;
                default:
                    Message.error(error.message)

            }
            return Promise.reject(error.response);
        }
    }
);
/**
 * postv3方法，对应postv3请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 接口重构v3版本
 */
export function postv3(url, params, tipText) {
    for (let key in params) {
        if (params[key] == null || params[key] == undefined) {
            params[key] = ""
        }
        if (typeof (params[key]) == "object") {
            params[key] = JSON.stringify(params[key])
        } else {
            params[key] = String(params[key]).trim()
        }
    }
    var paramsClone = params;
    //秒级时间戳
    var secondObj = {
        nonce: Math.random().toString(),
        timestamp: parseInt(new Date().getTime() / 1000)
    }
    for (var item in paramsClone) {
        secondObj[item] = paramsClone[item]
    }
    //排序，按参数的key排序（ascii码升序）
    var sorted = Object.keys(secondObj).sort().map(k => {
        return k + "=" + secondObj[k]
    }).join("&")
    //加密
    var sign = SHA1(sorted).toUpperCase();
    var urlStr = `${process.env.VUE_APP_APPV3}${url}?nonce=${secondObj.nonce}&timestamp=${secondObj.timestamp}&sign=${sign}`
    if (tipText) {
        var msg = Message.loading(tipText, 0)
    }
    return new Promise((resolve, reject) => {
        axios.post(urlStr, params)
            .then(res => {
                if (tipText) {
                    setTimeout(msg, 17);
                }
                resolve(res.data);
            })
            .catch(err => {
                if (tipText) {
                    setTimeout(msg, 17);
                }
                reject(err)
            })
    });
}
/**
 * getv3方法，对应getv3请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 接口重构v3版本
 */
export function getv3(url, params, tipText) {
    var paramsClone = params;
    //秒级时间戳
    var secondObj = {
        nonce: Math.random().toString(),
        timestamp: parseInt(new Date().getTime() / 1000)
    }
    for (var item in paramsClone) {
        secondObj[item] = paramsClone[item]
    }
    //排序，按参数的key排序（ascii码升序）
    var sorted = Object.keys(secondObj).sort().map(k => {
        return k + "=" + secondObj[k]
    }).join("&")
    //加密
    var sign = SHA1(sorted).toUpperCase();
    var urlStr = `${process.env.VUE_APP_APPV3}${url}?${sorted}&sign=${sign}`
    if (tipText) {
        var msg = Message.loading(tipText, 0)
    }

    return new Promise((resolve, reject) => {
        axios.get(urlStr, params)
            .then(res => {
                if (tipText) {
                    setTimeout(msg, 17);
                }
                resolve(res.data);
            })
            .catch(err => {
                if (tipText) {
                    setTimeout(msg, 17);
                }
                reject(err)
            })
    });
}
// /**
//  * get方法，对应get请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
// /**
//  * post方法，对应post请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
export function post(url, params, tipText) {
    if (tipText) {
        // Toast.loading({
        //     message: tipText,
        //     duration: 0
        // })
    } else {
        // Toast.loading({
        //     message: "加载中",
        //     duration: 0
        // })
    }

    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                // Toast.clear()
                console.log(res)
                console.log(res.data.errcode)
                if (res.data.errcode == 4002) {
                    console.log("token过期了")
                    console.log(res)
                    console.log("请求token过期的参数:", res.config.data)
                    console.log("请求token过期的url:", res.config.url)
                    getToken().then(res => {
                        console.log("拿到token了")
                        console.log(res)
                        resolve("Again")
                    }, err => {
                        resolve("appTokenOut")
                    })
                } else {
                    resolve(res.data);
                }

            })
            .catch(err => {
                // Toast.clear()
                reject(err.data)
            })
    });
}




//获取服务器时间
// export function getServiceTime() {
//     var xhr = null;
//     if (window.XMLHttpRequest) {
//         xhr = new window.XMLHttpRequest();
//     } else { // ie
//         xhr = new ActiveObject("Microsoft")
//     }
//     xhr.open("GET", location.href, false)
//     xhr.send(null);
//     var date = xhr.getResponseHeader("Date");
//     return new Date(date).getTime();
// }
// export function getToken() {
//     let count = localStorage.getItem("count") || 0;
//     let token = localStorage.getItem("app_token") || getCookie("access_token");
//     let temps = `access_token=${token}` + "&timestamp=" + getServiceTime()
//     console.info("加密后", getAesString(temps))
//     return new Promise((resolve, reject) => {
//         axios({
//             method: 'post',
//             url: `${process.env.VUE_APP_HOSPITAL}api/LojkOauth/getKfwzToken`,
//             data: QS.stringify({
//                 p: getAesString(temps)
//             }),
//             headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded'
//             }
//         }).then(res => {
//             console.log(res.data.StatusCode)
//             if (res.data.StatusCode == 200) {
//                 if (res.data.Data.code == 1) {
//                     localStorage.setItem("hToken", res.data.Data.token);
//                     localStorage.setItem("companyName", res.data.Data.companyName);
//                     localStorage.setItem("extendType", res.data.Data.companyType);
//                     resolve("Again")
//                 } else if (res.data.Data.code == 40001) {
//                     delCookie("access_token")
//                     delCookie("mobile")
//                     alert("登录过期")
//                     router.push({ path: "/login" })
//                 }
//             }
//         })
//     })
// }
// 写入带有自定义有效期的cookie
//  使用方式
//这是有设定过期时间的使用示例： 
//s20是代表20秒 
//h是指小时，如12小时则是：h12 
//d是天数，30天则：d30 

//用法示例 setCookie("name","hayden","s20");  cookie过期后会自动消失
export function setCookie(name, value, time) {
    var strsec = getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

//写入带有自定义有效期的cookie的辅助函数
export function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
        return str1 * 1000;
    } else if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
        return str1 * 24 * 60 * 60 * 1000;
    }
}

//读取cookies
export function getCookie(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
}

//删除cookies
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

//   对象深度克隆
export function cloneObj(obj) {
    let newObj = Array.isArray(obj) ? [] : {}
    if (obj && typeof obj === "object") {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                newObj[key] = (obj && typeof obj[key] === 'object') ? cloneObj(obj[key]) : obj[key];
            }
        }
    }
    return newObj
    // if (obj === null) return null
    // if (typeof obj !== 'object') return obj;
    // if (obj.constructor === Date) return new Date(obj);
    // var newObj = new obj.constructor();  //保持继承链
    // for (var key in obj) {
    //     if (obj.hasOwnProperty(key)) {   //不遍历其原型链上的属性
    //         var val = obj[key];
    //         newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; // 使用arguments.callee解除与函数名的耦合
    //     }
    // }
    // return newObj;
};

//  get请求方式参数转post请求参数 : "AppKey=123456&Token=&Name=1 =>{appKey:123456,Token:123}
export function getToPost(data) {
    var postData = {
        values: {}
    };
    var commonParam = data
    var item = ''
    var key = ''
    var val = ''
    let commonParamArr = commonParam.split('&');
    console.log(commonParamArr);
    console.log({ ...commonParamArr })
    for (var i = 0, len = commonParamArr.length; i < len; i++) {
        item = commonParamArr[i].split('=');
        key = item[0];
        val = item[1];
        // 排除commonParam内uid、token字段
        if (key == 'uid' || key == 'token') continue;
        postData.values[key] = val;
    }
    console.log(postData.values);
}
export function clearAllCookie() {
    var date = new Date();
    date.setTime(date.getTime() - 10000);
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    console.log("需要删除的cookie名字：" + keys);
    if (keys) { for (var i = keys.length; i--;)               document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/"; }
}
export function addWaterMarker(str, nodes) {
    var can = document.createElement("canvas");
    //水印显示的背景容器
    var body = document.querySelector(nodes);
    body.appendChild(can);

    can.width = 200;
    can.height = 200;
    can.style.display = "none";

    var cans = can.getContext("2d");
    cans.rotate((-20 * Math.PI) / 90);
    cans.font = "12px Microsoft JhengHei";
    cans.fillStyle = "rgba(17, 17, 17, 0.50)";
    cans.fillStyle = " #EBEBEB";
    cans.textAlign = "center";
    cans.textBaseline = "Middle";
    cans.fillText(str, can.width / 3, can.height / 2);

    body.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
}
/*
 *String strAge
 *格式 strAge="2000-03-22"
 */
export function getAge(strAge) {
    var birArr = strAge.split("-");
    var birYear = birArr[0];
    var birMonth = birArr[1];
    var birDay = birArr[2];

    d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1; //记得加1
    var nowDay = d.getDate();
    var returnAge;

    if (birArr == null) {
        return false
    };
    var d = new Date(birYear, birMonth - 1, birDay);
    if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
        if (nowYear == birYear) {
            returnAge = (nowMonth - (d.getMonth() + 1)) + "月";
        } else {
            var ageDiff = nowYear - birYear; // 
            if (ageDiff > 0) {
                if (nowMonth == birMonth) {
                    var dayDiff = nowDay - birDay; // 
                    if (dayDiff < 0) {
                        returnAge = (ageDiff - 1) + "岁";
                    } else {
                        returnAge = ageDiff + "岁";
                    }
                } else {
                    var monthDiff = nowMonth - birMonth; // 
                    if (monthDiff < 0) {
                        returnAge = (ageDiff - 1) + "岁";
                    } else {
                        returnAge = (ageDiff) + "岁";
                    }
                }
            } else {
                return "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
            }
        }
        return returnAge;
    } else {
        return ("输入的日期格式错误！");
    }
}